import { createSelector } from "@reduxjs/toolkit";
import type { TransactionApiItem } from "./userTransactionType";

type RootState = any; // replace with your RootState import if available

const selectTransactionsState = (s: RootState) => s.transactions;

function monthKey(iso: string): string {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "UNKNOWN";
  const month = d.toLocaleString("en-IN", { month: "long" }).toUpperCase();
  const year = d.getFullYear();
  return `${month} ${year}`;
}

export const selectTransactions = createSelector(
  selectTransactionsState,
  (st) => st.items as TransactionApiItem[],
);

export const selectTransactionsMeta = createSelector(
  selectTransactionsState,
  (st) => ({
    pageNumber: st.pageNumber,
    pageSize: st.pageSize,
    totalCount: st.totalCount,
    totalPages: st.totalPages,
    hasNext: st.hasNext,
    hasPrev: st.hasPrev,
    loading: st.loading,
    error: st.error,
    initialized: st.initialized,
  }),
);

export const selectGroupedTransactions = createSelector(
  selectTransactions,
  (items) => {
    const groups: Record<string, TransactionApiItem[]> = {};

    for (const tx of items) {
      const key = monthKey(tx.createdAt);
      if (!groups[key]) groups[key] = [];
      groups[key].push(tx);
    }

    // preserve order: newest group first based on first tx date
    const orderedKeys = Object.keys(groups).sort((a, b) => {
      const da = Date.parse(groups[a]?.[0]?.createdAt ?? "");
      const db = Date.parse(groups[b]?.[0]?.createdAt ?? "");
      return (Number.isNaN(db) ? 0 : db) - (Number.isNaN(da) ? 0 : da);
    });

    return orderedKeys.map((k) => ({
      title: k,
      items: groups[k].sort(
        (x, y) => Date.parse(y.createdAt) - Date.parse(x.createdAt),
      ),
    }));
  },
);
